import React from 'react';

interface GiftCardIconProps {
  className?: string;
}

const GiftCardIcon = ({ className = '', ...props }: GiftCardIconProps) => (
  <svg
    className={className}
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4C2.89543 4 2 4.89543 2 6V10.5625H4.80558C4.55851 10.3523 4.35514 10.1187 4.20933 9.87544C3.96126 9.46165 3.83503 8.92963 4.11754 8.46369C4.40004 7.99774 4.94701 7.83583 5.44737 7.83351C5.96163 7.83112 6.53718 7.98857 7.07005 8.28153C7.39163 8.45832 7.6761 8.67262 7.90717 8.90824V4H4Z"
      fill="currentColor"
    />
    <path
      d="M8.89169 4V7.82981C8.9634 7.76427 9.03858 7.70069 9.11698 7.63944C9.59265 7.26778 10.1336 7.0232 10.6414 6.94583C11.1355 6.87056 11.7028 6.94551 12.0612 7.36144C12.4196 7.77737 12.3861 8.32187 12.212 8.76859C12.0332 9.22773 11.6757 9.68517 11.2 10.0568C10.9278 10.2695 10.6342 10.4406 10.3377 10.5625L21.6904 10.5625L21.6904 6C21.6904 4.89543 20.795 4 19.6904 4H8.89169Z"
      fill="currentColor"
    />
    <path
      d="M21.6904 11.5L10.2838 11.5L12.5412 13.6496L11.845 14.3125L8.89169 11.5002V19H19.6904C20.795 19 21.6904 18.1046 21.6904 17L21.6904 11.5Z"
      fill="currentColor"
    />
    <path
      d="M7.90717 19V11.8578L5.66297 14.0785L4.95357 13.4285L6.90242 11.5L2 11.5V17C2 18.1046 2.89543 19 4 19H7.90717Z"
      fill="currentColor"
    />
    <path
      d="M9.74148 8.36419C10.1065 8.07899 10.4899 7.91834 10.797 7.87156C11.1177 7.82268 11.2558 7.90464 11.3001 7.95612C11.3445 8.0076 11.402 8.15251 11.289 8.44256C11.1808 8.72019 10.9405 9.04688 10.5755 9.33208C10.2105 9.61728 9.82707 9.77793 9.52001 9.82471C9.19922 9.87359 9.06119 9.79163 9.01683 9.74015C8.97247 9.68867 8.91501 9.54376 9.02799 9.25371C9.13614 8.97608 9.37646 8.6494 9.74148 8.36419Z"
      fill="currentColor"
    />
    <path
      d="M5.06434 9.41065C5.21851 9.66781 5.51148 9.95288 5.92039 10.1777C6.3293 10.4025 6.73505 10.5016 7.04601 10.5001C7.37088 10.4986 7.49306 10.3964 7.52802 10.3387C7.56298 10.281 7.5949 10.1291 7.43384 9.86047C7.27967 9.60331 6.9867 9.31824 6.57779 9.09343C6.16888 8.86862 5.76313 8.76955 5.45217 8.771C5.1273 8.7725 5.00512 8.87477 4.97016 8.93244C4.93519 8.9901 4.90328 9.14199 5.06434 9.41065Z"
      fill="currentColor"
    />
  </svg>
);

export default GiftCardIcon;
